import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectSyncRoutes = [
  {
    path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/sync/groups',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Sync with sources')
      },
      permissions: ['READ_SYNC_GROUPS']
    },
    children: [
      {
        path: '',
        name: 'syncGroupsList',
        component: wrapLegacyRoute('syncGroupsController', 'list')
      },
      {
        path: 'create',
        name: 'syncGroupCreate',
        component: wrapLegacyRoute('syncGroupsController', 'create')
      },
      {
        path: ':groupId(\\d+)',
        name: 'syncGroupDetails',
        component: wrapLegacyRoute('syncGroupsController', 'details')
      }
    ]
  }
];

export default projectSyncRoutes;
